import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return [];
  }
 
  
  initialize(){

  }

  visit(e){
    e.preventDefault();
    let scroll = window.pageYOffset; 
    Turbolinks.visit(e.target.href);
    window.scroll(0, [scroll]);

  }

  submit(e){
    e.preventDefault();
    let scroll = window.pageYOffset; 
    let handleScroll = function(){ 
      window.scroll(0, [scroll]);
      document.removeEventListener('turbolinks:load', handleScroll);

    }
     document.addEventListener('turbolinks:load', handleScroll); 

  }
} 


// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/persist_scroll_controller.js